module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "new_bot flex justify-center align-center pointer",
    on: {
      "click": _vm.shownow
    }
  }, [_c('div', {
    staticClass: "bot_text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "bot_btn"
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "联系电话",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticClass: "phone-dialog"
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "label": "联系电话:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "font-size": "18px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.config.phone) + "\n                        ")])])])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96527144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/call-view.vue
// module id = 413
// module chunks = 1